"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useImageLoader;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

useImageLoader.defaultProps = {
  onError: function onError() {}
};

function useImageLoader(props) {
  var imageRef = _react["default"].useRef();

  var _React$useState = _react["default"].useState(props.placeholder),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      image = _React$useState2[0],
      setImage = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(true),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      isLoading = _React$useState4[0],
      setIsLoading = _React$useState4[1];

  var onLoad = _react["default"].useCallback(function () {
    if (props.delay) {
      setTimeout(function () {
        return setImage();
      }, props.delay);
    } else {
      setImage(imageRef.current.src);
      setIsLoading(false);
    }
  }, [props.delay]);

  var loadImage = _react["default"].useCallback(function (src) {
    // If the image has already been loaded, we nullify the onload and onerror props
    // so it does not incorrectly set state when it resolves.
    if (imageRef.current) {
      image.onload = null;
      image.onerror = null;
    }

    imageRef.current = new Image();
    imageRef.current.src = src;
    imageRef.current.onload = onLoad;
    imageRef.current.onerror = props.onError;
  }, [props.onError, image.onload, image.onerror, onLoad]);

  function cleanup() {
    if (imageRef) {
      imageRef.current.onload = null;
      imageRef.current.onerror = null;
    }
  }

  _react["default"].useEffect(function () {
    loadImage(props.src);
    return cleanup;
  }, [props.src, loadImage]);

  return [image, isLoading];
}